class OrganizationFollowRepository extends Repository<{ follow: boolean }> {
  getFollowStatus(organizationId: number) {
    return this._get({ url: `/organizations/follow/${organizationId}` });
  }

  toggleFollowStatus(organizationId: number, currentStatus?: boolean) {
    return this._update({
      url: `/organizations/follow/${organizationId}`,
      data: { follow: currentStatus },
    });
  }
}

export const organizationFollowRepository = new OrganizationFollowRepository();
